/* SignUp.js */

import React, { useCallback, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Card, CardBody, Col, Container, Form, FormGroup, Row } from 'reactstrap';
import { useForm } from 'react-hook-form';

import { toast } from 'react-toastify';
import WAM from '../../services/WAM';
import Strings from '../../translations/Translations';
import Button1 from '../../components/buttons/Button1';

export default function SignUp() {
  const history = useHistory();
  const { register, handleSubmit, formState: { errors }, reset } = useForm();
  const [loading, setLoading] = useState(false);

  const onSubmit = useCallback(async ({ username, email, password}) => {
    setLoading(true);

    try {
      const response = await WAM.signup(username, email, password);

      if (response.result === 'success') {
        toast.success(Strings('user_successfully_created'));
        reset();
        history.replace('/login');
      } else {
        const message = (response && response.error) ? response.error : Strings('error_on_create_user');
        toast.error(message);
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      toast.error(Strings('general_error'));
    }
  }, [setLoading, reset, history]);

  return (
    <div className='pb-bg-1'>
      <Container>
        <Row className='login-page justify-content-center align-items-center'>
          <Col md={6}>
            <Card className='p-2 shadow'>
              <CardBody>
                <div className='mb-4'>
                  <h1 className="h2 modal-title">{Strings('application_title')}</h1>
                </div>
                
                <div className='mb-2 mb-0'>
                  <h6 className="opacity-8">{Strings('create_your_account')}</h6>
                </div>

                <Form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
                  <Row>
                    <Col md={12}>
                      <FormGroup>
                        <input
                          type='text'
                          name='username'
                          placeholder={Strings('username')}
                          {...register('username', { required: true })}
                          className='form-control pb-input-1'
                        />
                        {errors && errors.username && errors.username.type === 'required' && (
                          <p role='alert' className='text-danger txt-small-1'>{Strings('username_is_required')}</p>
                        )}
                      </FormGroup>
                    </Col>
                    <Col md={12}>
                      <FormGroup>
                        <input
                          type='email'
                          name='email'
                          placeholder={Strings('email')}
                          {...register('email', { required: true })}
                          className='form-control pb-input-1'
                        />
                        {errors && errors.email && errors.email.type === 'required' && (
                          <p role='alert' className='text-danger txt-small-1'>{Strings('email_is_required')}</p>
                        )}
                      </FormGroup>
                    </Col>
                    <Col md={12}>
                      <FormGroup>
                        <input
                          type='password'
                          name='password'
                          placeholder={Strings('password')}
                          {...register('password', { required: true })}
                          className='form-control pb-input-1'
                        />
                        {errors && errors.password && errors.password.type === 'required' && (
                          <p role='alert' className='text-danger txt-small-1'>{Strings('password_is_required')}</p>
                        )}
                      </FormGroup>
                    </Col>
                    <Col md={12} className='mb-4'>
                      <div className="text-center">
                        <small>
                          {Strings('by_signing_up_you_agree_with_our')} <a href="https://www.photozig.com/policies/terms.htm" target="_blank" rel="noreferrer noopener">{Strings('terms_and_conditions')}</a> / <a href="https://www.photozig.com/policies/privacy.html" target="_blank" rel="noreferrer noopener">{Strings('privacy_policy')}</a>.
                          </small>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <div className="mt-2 mb-2 d-flex justify-content-between">
                      <Link className="pb-link-1" to="/login">
                        {Strings('return_to_login')}
                      </Link>
                    </div>

                    <div className='d-flex justify-content-center'>
                      <Button1 className='pb-btn-1' type='submit' size="lg" onClick={handleSubmit(onSubmit)} loading={loading}>
                        {Strings('create_account')}
                      </Button1>
                    </div>
                  </Row>
                </Form>

                <div className="text-center opacity-8 mt-3">
                  Copyright &copy; Photozig Inc.
                </div>
              </CardBody>
              
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
